export default __webpack_public_path__ + "static/media/gallery-03_full.49e5aacd.jpg";